/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Tour_HintInputs */



/**
* | output |
* | --- |
* | "Click anywhere or press any key to continue; ← goes back" |
*
* @param {Onboarding_Tour_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_tour_hint = /** @type {((inputs?: Onboarding_Tour_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Tour_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Klicke irgendwo oder drücke eine Taste, um fortzufahren; ← geht zurück")
	return /** @type {LocalizedString} */ ("Click anywhere or press any key to continue; ← goes back")
});